import { render, staticRenderFns } from "./BannerCat.vue?vue&type=template&id=73a485d9&scoped=true&"
import script from "./BannerCat.vue?vue&type=script&lang=js&"
export * from "./BannerCat.vue?vue&type=script&lang=js&"
import style0 from "./BannerCat.vue?vue&type=style&index=0&id=73a485d9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a485d9",
  null
  
)

export default component.exports